<template>
  <div class="container-fluid">
    <section-title
      has-line
      content="Justificación"
      :class="isMobile ? 'section-title' : ''"
    />

    <div class="row d-flex justify-content-start">
      <div class="col-md-12 col-12">
        <ValidationProvider v-slot="{ errors }" rules="required">
          <CustomTextArea
            id="justification"
            v-model="model.justification"
            :maxlength="3000"
            :count-classes="['d-block text-right']"
            show-char-count
            :disabled="readonly"
            :error="errors[0]"
            custom-error-msg="La justificación es requerida."
          />
        </ValidationProvider>
      </div>
    </div>
  </div>
</template>

<script>
import CustomTextArea from 'CustomTextArea';
import SectionTitle from 'SectionTitle';

export default {
  name: 'Justification',
  components: {
    SectionTitle,
    CustomTextArea,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    readonly: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    model() {
      return this.value;
    },
    isMobile() {
      return this.$store.getters.getIsMobileDensity;
    },
  },
};
</script>
